import { useAppConfigContext } from "../context/AppConfigContext";

const SERVICE_LABELS = {
  rides: "Rides",
  stays: "Stays",
  puloAssistants: "Pulo Assistants",
};

/**
 * Wraps a route that belongs to one of the Settings > Service Modules
 * toggles (Rides/Stays/Pulo Assistants). When the admin has switched the
 * module off, this shows a scoped "temporarily unavailable" message instead
 * of the page, mirroring the 403 the backend now returns for the same
 * disabled service on its API routes.
 */
export default function ServiceGuard({ service, children }) {
  const { isServiceEnabled, isLoading } = useAppConfigContext();

  if (isLoading) return null;

  if (!isServiceEnabled(service)) {
    return (
      <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-6 text-center">
        <h1 className="text-2xl font-bold text-[#61013B]">
          {SERVICE_LABELS[service] || "This service"} is currently unavailable
        </h1>
        <p className="max-w-md text-gray-600">
          This part of Pulo has been temporarily disabled by an administrator.
          Please check back later.
        </p>
      </div>
    );
  }

  return children;
}
